export default __webpack_public_path__ + "static/media/ICON_Withdraw.d98dccce.svg";